module.exports = __webpack_public_path__ + "static/media/header.5e4c1db2.png";